import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";

interface AspirasiFormProps {
  presidenId: number; // ⬅️ dikirim dari DetailPageUtama
}

const AspirasiForm: React.FC<AspirasiFormProps> = ({ presidenId }) => {
  const [judul, setJudul] = useState("");
  const [aspirasi, setAspirasi] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  // state untuk data aspirasi list
  const [aspirasiList, setAspirasiList] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  // fetch aspirasi sudah ditindaklanjuti
  const fetchAspirasi = async (pageNum = 1) => {
    try {
      const token = Cookies.get("token");
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/aspirasi/presiden/${presidenId}?&page=${pageNum}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAspirasiList(res.data.data);
      setPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.error("Gagal fetch aspirasi:", err);
    }
  };

  useEffect(() => {
    fetchAspirasi(1);
  }, [presidenId]);

  // kirim aspirasi
  const handleSubmit = async () => {
    if (!judul || !aspirasi) return;
    setLoading(true);

    try {
      const token = Cookies.get("token");
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/aspirasi`,
        {
          presiden_id: presidenId,
          judul,
          deskripsi: aspirasi,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setShowPopup(true);
      setJudul("");
      setAspirasi("");

      // refresh aspirasi list
      fetchAspirasi(1);
    } catch (err) {
      console.error("Gagal mengirim aspirasi:", err);
      alert("Gagal mengirim aspirasi, coba lagi!");
    } finally {
      setLoading(false);
    }
  };

  // validasi: semua field harus terisi
  const isDisabled = !judul.trim() || !aspirasi.trim() || loading;

  return (
    <div className="mt-4 bg-transparent p-6 rounded-xl shadow-md">
      <h2 className="text-xl font-semibold mb-4 text-yellow-800">Sampaikan Aspirasi Anda</h2>
      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">Judul</label>

        <input type="text" placeholder="Judul" value={judul} onChange={(e) => setJudul(e.target.value)} className="w-full border p-2 rounded " />
      </div>

      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">Aspirasi</label>
        <textarea placeholder="Tuliskan aspirasi anda..." value={aspirasi} onChange={(e) => setAspirasi(e.target.value)} className="w-full border p-2 rounded h-28" />
      </div>

      {/* Upload Foto */}
      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">Upload Foto</label>
        <input
          type="file"
          accept="image/*"
          // onChange={(e) => setFoto(e.target.files?.[0] || null)}
          className="w-full border p-2 rounded bg-white"
        />
      </div>

      {/* Upload Video */}
      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700 mb-1 ">Upload Video</label>
        <input
          type="file"
          accept="video/*"
          // onChange={(e) => setVideo(e.target.files?.[0] || null)}
          className="w-full border p-2 rounded bg-white"
        />
      </div>

      <div className="flex justify-end">
        <button onClick={handleSubmit} disabled={isDisabled} className={`px-4 py-2 rounded text-white ${isDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-yellow-600 hover:bg-yellow-700"}`}>
          {loading ? "Mengirim..." : "Kirim"}
        </button>
      </div>

      {/* Popup sukses */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg text-center">
            <p className="text-lg font-semibold text-gray-700">
              Aspirasi anda telah dikirim
              <br />
              Terima kasih 🙏
            </p>
            <button onClick={() => setShowPopup(false)} className="mt-4 bg-yellow-600 text-white px-4 py-2 rounded hover:bg-yellow-700">
              Tutup
            </button>
          </div>
        </div>
      )}

      {/* List aspirasi */}
      <div className="mt-12">
        <h3 className="text-lg font-semibold mb-3 text-yellow-800">Aspirasi yang sudah ditindak lanjuti</h3>
        {aspirasiList.length === 0 ? (
          <p className="text-gray-500">Belum ada aspirasi.</p>
        ) : (
          <ul className="space-y-4">
            {aspirasiList.map((item) => (
              <li key={item.id} className="border p-4 rounded-lg shadow-sm bg-white">
                <p className="font-bold">{item.judul}</p>
                <p className="text-gray-700">{item.deskripsi}</p>
                {item.balasan && (
                  <p className="text-green-600 mt-2">
                    <span className="font-semibold">Balasan: </span>
                    {item.balasan}
                  </p>
                )}
                <p className="text-sm text-gray-400 mt-1">
                  oleh {item.user?.name} • {new Date(item.created_at).toLocaleString()}
                </p>
              </li>
            ))}
          </ul>
        )}

        {/* Pagination */}
        <div className="flex justify-end gap-2 mt-7">
          <button onClick={() => fetchAspirasi(page - 1)} disabled={page <= 1} className="px-3 py-1 rounded bg-yellow-800 disabled:opacity-50 text-white">
            Prev
          </button>
          <div className="px-3 py-1 border border-yellow-800 text-sm rounded">
            {page} / {lastPage}
          </div>
          <button onClick={() => fetchAspirasi(page + 1)} disabled={page >= lastPage} className="px-3 py-1 rounded bg-yellow-800 disabled:opacity-50 text-white">
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default AspirasiForm;
